import { Heart } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { useT } from "../../i18n/LanguageContext";

const copy = {
  en: { donate: "Donate" },
  fr: { donate: "Donner" },
};

export default function FloatingDonate() {
  const t = useT(copy);
  const location = useLocation();
  const navigate = useNavigate();
  const onClick = (e) => {
    e.preventDefault();
    if (location.pathname === "/") {
      document.getElementById("donate")?.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/#donate");
      setTimeout(() => {
        document.getElementById("donate")?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
  };
  return (
    <a
      href="/#donate"
      onClick={onClick}
      data-testid="stories-persistent-donate"
      className="fixed bottom-6 left-6 z-50 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#E3282B] text-white font-bold shadow-2xl hover:bg-[#00A651] transition-colors"
    >
      <Heart size={16} fill="white" />
      {t.donate}
    </a>
  );
}
